<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrProsesTablo from "@/models/StrProsesTablo.js";
import StrProsesTabloAlt from "./Index.vue";

import { EventBus } from  "@/main"

export default {
  mixins: [Api, Sabit, StrProsesTablo],
  props: ["Prosesid", "Ustid","Seviye"],
  name:"StrProsesTabloAlt",
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      DataUpdateAlt: "",
      Gosterge: null,
       siralama:"&Asc=Sirano",
    };
  },
  component: {
    StrProsesTabloAlt,

  },

  watch: {
    Guncelle() {
      this.Get();
    },
  },

  methods: {
    duzeltme(data) {
      EventBus.$emit("Duzeltme",data);

    },

    ekleme(Prosesid,Seviye,Ustid) {
      EventBus.$emit("Ekleme",[Prosesid,Seviye,Ustid])

    },



    Get() {

       let Filter = "&Prosesid=" + this.Prosesid+"&Seviye="+this.Seviye;

       if (this.Ustid!="" && this.Ustid!=null) {
        Filter=Filter+"&Ustid="+this.Ustid;}

        if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
        }

        console.log(Filter)

      this.ActionsFilterGet({ Service: "StrProsesTablo", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
  created() {
        this.Get();

    EventBus.$on("TableUpdate",(seviye)=>{
 
          if(this.Seviye==seviye){
       
              this.Get();
          }
     });

  },
};
</script>
<template>
  <div>

    <table v-if="TableData.length>0" class="table table-striped table-bordered mb-0">
      <thead>
        <tr>
          <th scope="col" style="width:50px"></th>
          <th scope="col" style="width:100px">{{ $t("StrProsesTablo.Table.Sirano") }}
            <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
            <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
            </th>
          <th scope="col"> <span v-if="Seviye == 1">{{ $t("StrProsesTablo.Table.Hedefadi") }}</span>  
            <span v-if="Seviye == 2">{{ $t("StrProsesTablo.Table.Eylemadi") }}</span>  
            <span v-if="Seviye == 3">{{ $t("StrProsesTablo.Table.Gostergeadi") }}</span>  
          <i style="margin-left:10px" v-if="siralama!='&Asc=GostergeTipi'" @click="siralama='&Asc=GostergeTipi', Get()" class="bx bx-sort-a-z fa-xl"></i>
            <i style="margin-left:10px" v-if="siralama=='&Asc=GostergeTipi'" @click="siralama='&Desc=GostergeTipi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
            </th>

          <th style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("StrProsesTablo.Table.Islem") }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="tablo in TableData" >
        <tr :key="tablo.Id">
          <th scope="row" class="custom-accordion">
                      <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" 
                      v-b-toggle="'CollapseAltTablo' + tablo.Id" role="button" aria-expanded="false" 
                      aria-controls="categories-collapse">
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
          <td>{{ tablo.Sirano }}</td>
          <td>{{ tablo.Tabloadi }} </td>
          

          <td style="width: 85px; text-align: center; vertical-align: middle;">

            <b-button-group>
          
                <b-button v-if="Seviye<3" variant="primary" 
                  v-b-modal.StrProsesTablo 
                  @click="ekleme(Prosesid, Seviye+1, tablo.Id)">
                  <i class="fas fa-plus"></i>
                </b-button>
                
                <b-button variant="success" v-b-modal.StrProsesTablo 
                @click="duzeltme(tablo)">
                <i class="fas fa-pencil-alt"></i></b-button>

                <b-button variant="danger" @click="Delete('StrProsesTablo', tablo.Id)"><i class="fas fa-trash-alt"></i></b-button>
            </b-button-group>
            
          </td>
        </tr>
        <tr :key="tablo.Id">

          
            <td></td>
            <td colspan="3">
              <b-collapse b-collapse class="collapse show" :id="'CollapseAltTablo' + tablo.Id">
            
              <StrProsesTabloAlt 
              :Prosesid="tablo.Prosesid"  
              :Ustid="tablo.Id" 
              :Seviye="(tablo.Seviye+1)"
              />
            </b-collapse>

            </td>
     

        </tr>
      </template>
      </tbody>
    </table>



  </div>
</template>
